module.exports = __webpack_public_path__ + "static/media/customers-logo-strip.5f12b0dc.png";